import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { Separator } from '../../common/Separator';
import {
  IMediaUploadItemProps,
  MediaUploadItem,
} from './MediaUploadItem';
import { splitIntoChunks } from '@utils';

const Container = styled(View)({
  flex: 1,
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const ChunkContainer = styled(View)({
  width: '100%',
});

const ChunkRow = styled(View)({
  flexDirection: 'row',
  width: '100%',
});

export interface IMediaUploadViewProps {
  items: IMediaUploadItemProps['item'][];
  onRemove(item: IMediaUploadItemProps['item']): void;
}

export const MediaUploadView = observer<IMediaUploadViewProps>(
  ({ items, onRemove }) => {
    return (
      <Container>
        {splitIntoChunks(items).map(
          (chunk, chunkIndex, chunksArray) => {
            const isLastChunk = chunksArray.length === chunkIndex + 1;

            return (
              <ChunkContainer key={chunkIndex}>
                <ChunkRow>
                  {chunk.map((item, index, array) => {
                    const isLastItem = array.length === index + 1;

                    return (
                      <React.Fragment key={item.id}>
                        <MediaUploadItem
                          item={item}
                          onRemove={onRemove}
                        />
                        {!isLastItem && (
                          <Separator size="$4" vertical />
                        )}
                      </React.Fragment>
                    );
                  })}
                </ChunkRow>
                {!isLastChunk && <Separator size="$4" />}
              </ChunkContainer>
            );
          },
        )}
      </Container>
    );
  },
);
